import { REQUEST_PAYMENT_HISTORY_SUCCESS, REQUEST_PAYMENT_HISTORY_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], errors: null };

export default function paymentHistory(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_PAYMENT_HISTORY_SUCCESS:
      return { ids: action.payload.data.map((data) => data.id), errors: null };
    case REQUEST_PAYMENT_HISTORY_FAILURE:
      return { ids: [], errors: action.payload.response && action.payload.response.data.errors };
    default:
      return state;
  }
}
